/* eslint-disable */
import { bmsUiHttp, bmsWebHttp } from '@/utils/http/index.js'

const auditWeb = '/hope-saas-audit-web'
/**
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/24715
 * 账单列表
 */
export function getBillList(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/ts/page`, data, { from: 'bms' })
}

/**
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/24729
 * 退回账单
 */
export function backBill(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/rollback_bill`, data, { from: 'bms' })
}

/**
 * 确认账单
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/24727
 */
export function checkBill(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/confirm_bill`, data, { from: 'bms' })
}
/**
 * 账单详情
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/24717
 */
export function billDetail(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/ts/detail`, data, { from: 'bms' })
}

// 账单调整
export function getAdjustDetail(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/ts/adjust/page`, data, { from: 'bms' })
}


/**
 * 开票明细
 * https://yapi.ops.yunlizhi.cn/project/218/interface/api/17521 
 */
export function getInvoiceDetail(data) {
    return bmsWebHttp.post(`/bms_plus/income_invoice/bill/associate_detail`, data, { from: 'bms' })
}

/**
 * 清分明细
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/35342
 */
export function getClearDetail(data) {
    return bmsWebHttp.post(`/bfs_pricing_rule/clarify_detail/search`, data, { from: 'bms' })
}


/**
 * https://yapi.ops.yunlizhi.cn/project/373/interface/api/24789
 * 账单下载
 */

export function billDownloadExcel(data) {
    return bmsUiHttp.post(`${auditWeb}/cct_bill/ts/bill_download_excel`, data, { from: 'bms' })
}
